import React from 'react';
import PropTypes from 'prop-types';
import styles from './Loading.module.css';

const Loading = ({ isLoadingAdminPage = false }) => {
  return (
    <div
      className={`${styles.loadingContainer} ${isLoadingAdminPage ? styles.adminPageLoadingContainer : ''}`}
    >
      <div className={styles.spinner}></div>
    </div>
  );
};

Loading.propTypes = {
  isLoadingAdminPage: PropTypes.bool,
};

export default Loading;
